var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",style:(_vm.options.series[0].data.length > 0
      ? 'min-height: 400px; width: 100%'
      : 'min-height: 400px; width: 100%; visibility: hidden'),attrs:{"id":"container"}})}
var staticRenderFns = []

export { render, staticRenderFns }